/**
 * USt-IdNr (Deutschland): "DE" + 9 Ziffern. Format-/Längenprüfung (keine
 * Prüfziffer). Entfernt alle Nicht-Alphanumerischen (auch Zero-Width/NBSP aus
 * Copy-Paste), bevor geprüft wird.
 */

export function normalizeUstIdNr(input: string): string {
  let s = String(input ?? "").toUpperCase().replace(/[^A-Z0-9]/g, "");
  if (/^\d{9}$/.test(s)) s = "DE" + s; // 9 nackte Ziffern → DE voranstellen
  return s;
}

/** Leer = gültig (optionales Feld). */
export function validateUstIdNr(input: string): { valid: boolean; error?: string } {
  if (!String(input ?? "").trim()) return { valid: true };
  return /^DE\d{9}$/.test(normalizeUstIdNr(input))
    ? { valid: true }
    : { valid: false, error: "Format: DE + 9 Ziffern" };
}
